import { Axios } from "index";

export const veneerItemSrnoDropdownApi = "/veneer-inventory/item-srno-dropdown";
export const veneerInwardSrnoDropdownApi = "/veneer-inventory/inward-srno-dropdown";

//Approval
export const fetchVeneerApprovalApi = `/approval/veneer-approval-invoice-listing`;
export const fetchVeneerItemsApprovalApi = function (id, invoice_id) {
  return `/approval/veneer-approval-item-listing-by-invoice/${id}/${invoice_id}`;
};
export const veneerApproveInvoiceApi = function (id, invoice_id) {
  return `/approval/veneer-approve_invoice_details/${id}/${invoice_id}`;
};
export const veneerRejectInvoiceApi = function (id, invoice_id) {
  return `/approval/veneer-reject_invoice_details/${id}/${invoice_id}`;
};

export const dropdownLogByOrderItemIdApi = async (_id) => {
  const res = await Axios.get(`/veneer-inventory/log-no-dropdown/${_id}`);
  return res;
};

export const dropdownPalletNoDropdownByLogNoApi = async (logCode) => {
  const res = await Axios.get(`/veneer-inventory/pallet-no-dropdown/${logCode}`);
  return res;
};

export const dropdownBundleNoDropdownByPalletNoApi = async (logCode) => {
  const res = await Axios.get(`/veneer-inventory/bundle-no-dropdown/${logCode}`);
  return res;
};

export const listVennerDetailsByBundleIdApi = async (id) => {
  const res = await Axios.get(`/veneer-inventory/list-veneer-details/${id}`);
  return res;
};

export const issueRawVeneerOrderdApi = async (data) => {
  const res = await Axios.post(`/order/issue-raw-venner-order/issue-order`, data);
  return res;
};

export const revertVeneerOrderApi = async (id) => {
  const res = await Axios.post(`/order/revert-order/${id}`);
  return res;
};